type UploadError = { code?: string; index?: number; value?: string };

/** Uploaded rows whose country was not recognised, e.g. " Invalid country: row 3 (Narnia)." */
export default function invalidCountryRows(errors: UploadError[] = []): string {
  const rows = errors
    .filter((error) => error?.code === "INVALID_COUNTRY")
    .map((error) => `row ${error.index}${error.value ? ` (${error.value})` : ""}`);
  return rows.length ? ` Invalid country: ${rows.join(", ")}.` : "";
}
